<nav
  class="flex h-dvh w-52 flex-col overflow-auto bg-primary-950 transition-all duration-300 fixed inset-y-0 left-0 z-[60] lg:static lg:z-auto lg:translate-x-0"
  [class.-translate-x-full]="!layoutService.mobileNavOpen()"
  [class.translate-x-0]="layoutService.mobileNavOpen()"
  [ngClass]="
    layoutService.sidebarExpanded ? 'lg:w-52 xl:w-64' : 'lg:w-[70px]'
  ">
  <div
    class="flex topbar-height items-center border-white/10 px-4"
    [class.justify-center]="!layoutService.isNavChromeExpanded()"
    [class.justify-start]="layoutService.isNavChromeExpanded()">
    <div class="flex items-center gap-3">
      <img
        src="assets/brand/logo.svg"
        width="36"
        height="36"
        alt="FormOps logo"
        class="h-9 w-9 shrink-0 rounded-2xl bg-white p-1.5 shadow-lg shadow-black/20" />

      @if (layoutService.isNavChromeExpanded()) {
        <div>
          <p class="text-h6 font-bold text-white">Form Ops</p>
        </div>
      }
    </div>
  </div>

  <div class="border-b border-white/10 px-3 py-3">
    <button
      type="button"
      class="flex w-full cursor-pointer items-center gap-2.5 rounded-xl border border-white/10 bg-white/5 px-2.5 py-2 text-left transition hover:bg-white/10"
      [class.justify-center]="!layoutService.isNavChromeExpanded()"
      (click)="openWorkspaceSwitcher()">
      <span
        class="flex h-8 w-8 shrink-0 items-center justify-center rounded-lg text-sm font-semibold text-white"
        [ngClass]="workspaceAvatarClass()">
        {{ workspaceInitial() }}
      </span>

      @if (layoutService.isNavChromeExpanded()) {
        <span class="min-w-0 flex-1">
          <span class="block truncate text-caption font-medium uppercase tracking-wide text-slate-400">Workspace</span>
          <span class="block truncate text-sm font-medium text-white">{{ currentWorkspaceName() }}</span>
        </span>
        <app-svg-icon
          class="shrink-0 text-slate-300"
          src="assets/icons/unfold-more-horizontal.svg"
          [size]="16" />
      }
    </button>
  </div>

  <div class="flex grow flex-col gap-4 p-3">
    @if (!layoutService.isNavChromeExpanded()) {
      <div class="line bg-primary-500!"></div>
    }

    <div class="flex flex-col grow gap-2">
      @for (menu of mainMenus(); track menu.link) {
        @if (menu.isEnabled) {
          <app-sidebar-menu [menuItem]="menu" (click)="onMenuClick(menu)">{{ menu.label }}</app-sidebar-menu>
        }
      }

      <div class="h-px bg-slate-700!"></div>

      @if (layoutService.isNavChromeExpanded()) {
        <p class="px-3 text-caption font-medium uppercase tracking-wide text-slate-400 mt-4 mb-2">Workspace</p>
      } @else {
        <div class="line bg-primary-500!"></div>
      }

      @for (menu of workspaceMenus(); track menu.link) {
        @if (menu.isEnabled) {
          <app-sidebar-menu [menuItem]="menu" (click)="onMenuClick(menu)">{{ menu.label }}</app-sidebar-menu>
        }
      }
    </div>

    <div class="hidden w-full justify-end lg:flex">
      <div
        class="flex h-7 w-7 cursor-pointer items-center justify-center"
        (click)="toggleSidebar()">
        @if (layoutService.sidebarExpanded) {
          <app-svg-icon class="text-gray-200" src="assets/icons/chevron-double-left.svg"></app-svg-icon>
        } @else {
          <app-svg-icon class="text-gray-200" src="assets/icons/chevron-double-right.svg"></app-svg-icon>
        }
      </div>
    </div>
  </div>
</nav>
